import { render } from "./settingsSummaryRow.vue?vue&type=template&id=94e9d84a&scoped=true"
import script from "./settingsSummaryRow.vue?vue&type=script&lang=js"
export * from "./settingsSummaryRow.vue?vue&type=script&lang=js"

import "./settingsSummaryRow.vue?vue&type=style&index=0&id=94e9d84a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e9d84a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
